(function (Drupal) {
  Drupal.behaviors.logo = {
    attach: function(context,settings) {
      const logoHeader = document.getElementsByClassName('svg-logo');
      for (let i = 0; i < logoHeader.length; i++) {
        let element = logoHeader[i];
        let position = element.getBoundingClientRect().top;
        let windowHeight = window.innerHeight;
        if (position < windowHeight) {
          element.classList.add('active');
        } else {
          element.classList.remove('active');
        }
      }
      window.addEventListener('scroll', function() {
        const svgLogoFooter = document.getElementsByClassName('svg-logo-footer');
        for (let i = 0; i < svgLogoFooter.length; i++) {
          let element = svgLogoFooter[i];
          let position = element.getBoundingClientRect().top;
          let windowHeight = window.innerHeight;
          if (position < windowHeight) {
            element.classList.add('active');
          } else {
            element.classList.remove('active');
          }
          // element.addEventListener('mouseover', function() {
          //   element.classList.add('active');
          // });
          // element.addEventListener('mouseout', function() {
          //   element.classList.remove('active');
          // });
        }
      });
    }
  };
})(Drupal);
